import React, { PureComponent } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

export default class MBRModal extends PureComponent {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
  };

  render() {
    const {
      visible,
      children,
      className,
      contentLabel,
      buttonClose,
      onRequestClose,
      ...rest
    } = this.props;
    return (
      <Modal
        isOpen={visible}
        ariaHideApp={false}
        onRequestClose={onRequestClose}
        className={cn('modal', className)}
        {...rest}
      >
        <div className="modal_container">
          {buttonClose && (
            <button type="button" className="modal_close-button" onClick={onRequestClose} />
          )}
          <div className="modal_dialog">
            {contentLabel && <h2 className="modal_title">{contentLabel}</h2>}
            {/*<div className="modal_content" dangerouslySetInnerHTML={{ __html: children }} />*/}
            {children && <div className="modal_content">{children}</div>}
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/MBRModal/MBRModal.js